import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import App from './App.vue'
import router from './router.js'
import i18n from './i18n.js'
import { bootstrapTokenFromUrl } from './services/auth.js'

// При открытии co-pilot из S+ URL содержит ?token=... — сохраним в localStorage и почистим URL
bootstrapTokenFromUrl()

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(ElementPlus)
app.mount('#app')
